<template>
  <sticky-header-layout>
    Please Input Product ID:
    <el-input
      v-model="searchId"
      style="width: 200px"
      placeholder="Please input Product ID"
      @keyup.enter.native="handleClickSearch"
    />

    <el-button
      :loading="isSearching"
      :disabled="isSaving"
      class="ml-2"
      type="primary"
      @click="handleClickSearch"
    >{{ $t('button.search') }}</el-button>

    <div
      v-loading="isSaving"
      v-if="hasProduct"
    >
      <transition
        name="fade"
        mode="out-in"
      >
        <table class="text-left pt-3">
          <tr>
            <th>
              ID
            </th>
            <td>
              {{ product.id }}
            </td>
          </tr>
          <tr>
            <th>
              Name
            </th>
            <td>
              {{ product.product_name }}
            </td>
          </tr>
          <tr>
            <th>
              Description
            </th>
            <td>
              {{ product.description }}
            </td>
          </tr>
          <tr>
            <th>
              Image
            </th>
            <td>
              <img
                :src="product.imageurl"
                style="height:150px; width: auto;">
            </td>
          </tr>
          <tr>
            <th>
              Brand Name
            </th>
            <td>
              {{ product.brand_slug }}
            </td>
          </tr>
          <tr>
            <th>
              Store Name
            </th>
            <td>
              {{ product.store_slug }}
            </td>
          </tr>
          <tr>
            <th>
              Category
            </th>
            <td>
              <template v-if="!isEdit">
                <div>
                  {{ currentCategories }}
                  <edit-button
                    :disabled="isSearching"
                    class="ml-2"
                    @click="handleClickEdit"
                  />
                </div>
              </template>
              <template v-else>
                <div v-if="!isEditCat">
                  <el-button
                    class="ml-2"
                    type="danger"
                    @click="handleClickByCatSlug"
                  >By Category Slug</el-button>
                  <el-button
                    class="ml-2"
                    type="danger"
                    @click="handleClickByCatId"
                  >By Category ID</el-button>
                </div>
              </template>
              <template v-if="isEditCat">
                <div v-if="isEditCatSlug"
                  class="d-flex">
                  <category-selector
                    v-model="product.goxip_category"
                  />
                  <el-button
                    :disabled="isSearching"
                    class="ml-2"
                    type="danger"
                    @click="handleClickSave"
                  >{{ $t('button.save') }}</el-button>
                </div>
                <div v-if="isEditCatId"
                  class="d-flex">
                  <el-input
                    placeholder="Please input category id (M1,W1)"
                    v-model="inputCatId"
                    @keyup.enter.native="handleClickSaveId"
                  >
                  </el-input>
                  <el-button
                    :disabled="isSearching"
                    class="ml-2"
                    type="danger"
                    @click="handleClickSaveId"
                  >{{ $t('button.save') }}</el-button>
                </div>
              </template>
            </td>
          </tr>
        </table>
      </transition>
    </div>

  </sticky-header-layout>
</template>

<script>
import CategorySelector from '@/components/selectors/CategorySelector.vue'
import EditButton from '@/components/buttons/EditButton.vue'

import ProductsService from '../../api/products'

export default {
  name: 'ProductCategorize',
  components: {
    CategorySelector,
    EditButton,
  },
  data() {
    return {
      isSearching: false,
      isSaving: false,
      isEdit: false,
      searchId: '',
      product: {},
      inputCatId: '',
      isEditCat: false,
      isEditCatSlug: false,
      isEditCatId: false,
    }
  },
  computed: {
    hasProduct() {
      return !!this.product.id
    },
    currentCategories() {
      const categories = this.product.goxip_category || []
      return categories.join(', ') || '/'
    },
  },
  methods: {
    async searchProduct() {
      this.isSearching = true
      try {
        const { data } = await ProductsService.getProductById(this.searchId)
        this.isEdit = false
        this.product = data
        // this.searchId = ''
        this.$nextTick(() =>{
          this.isEditId = false
          this.isEditCatId = false
          this.isEditCat = false
          this.isEditCatSlug = false
          this.inputCatId = ''
        })
      } catch (error) {
        this.handleSearchFail(error)
      } finally {
        this.isSearching = false
      }
    },
    async saveUpdatedCategoryBySlug() {
      this.isSaving = true
      try {
        await ProductsService.updateProductCategoriesBySlug([
          {
            categories: this.product.goxip_category,
            product_id: this.product.id,
          },
        ])
        await this.searchProduct()
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      } finally {
        this.isSaving = false
      }
    },
    async saveUpdatedCategoryById() {
      this.isSaving = true
      try {
        await ProductsService.updateProductCategoriesById([
          {
            category_ids: this.inputCatId,
            product_id: this.product.id,
          },
        ])
        await this.searchProduct()
        this.handleSaveSuccess()
      } catch (error) {
        this.handleSaveFail(error)
      } finally {
        this.isSaving = false
      }
    },
    handleClickEdit() {
      this.isEdit = true
    },
    handleSearchFail(error) {
      this.$alert(`Error: ${error} `, this.$t('error.thisFieldMustBeAProductId'), {
        type: 'error',
        confirmButtonText: this.$t('button.ok'),
      })
    },
    async handleClickSearch() {
      this.searchProduct()
    },
    handleSaveSuccess() {
      this.$message({
        message: 'Product category updated.',
        type: 'success',
      })
      this.isEdit = false
      this.isEditCat = false
    },
    handleSaveFail(error) {
      this.$alert(`Error: ${error}`, this.$t('error.somethingWentWrong'), {
        type: 'error',
        confirmButtonText: this.$t('button.ok'),
      })
    },
    handleClickSave() {
      if (this.product.goxip_category.length === 0) {
        this.$alert('Please select at least one category', '', {
          confirmButtonText: 'OK',
        })
        return
      }
      this.saveUpdatedCategoryBySlug()
    },
    handleClickSaveId() {
      this.saveUpdatedCategoryById()
    },
    handleClickByCatSlug() {
      this.isEditCat = true
      this.isEditCatSlug = true
    },
    handleClickByCatId() {
      this.isEditCat = true
      this.isEditCatId = true
    },
  },
}

</script>

<style lang="scss" scoped>
th, td {
  padding: 8px 8px 8px 0;
}
th {
  width: 144px;
}
</style>
